import axios from 'axios'

export default {
    loadMenuCache(
        comCode: string,
        version: number
    ): Promise<appbase.cache.TMenuSource> {
        return axios({
            method: 'GET',
            url: `/cm/gres/libs/portal-cache/menu-${comCode.toLowerCase()}.json?ver=${version}`,
        }).then((res) => res.data)
    },
    loadQuickMenuCache(
        comCode: string,
        version: number
    ): Promise<appbase.cache.TMenuSource> {
        return axios({
            method: 'GET',
            url: `/cm/gres/libs/portal-cache/quick-menu-${comCode.toLowerCase()}.json?ver=${version}`,
        }).then((res) => res.data)
    },
    /**
     * 용어 캐시를 로드합니다.
     */
    loadDictionary(lang: string, version: number): Promise<any> {
        return axios({
            method: 'GET',
            url: `/cm/gres/libs/portal-cache/${lang}.json?ver=${version}`,
        }).then((res) => res.data)
    },
    /**
     * @deprecated loadWebpartCacheV3를 사용하세요.
     */
    loadWebpartCache(
        comCode: string,
        version: number
    ): Promise<appbase.cache.TWebpartSource[]> {
        return axios({
            method: 'GET',
            url: `/cm/gres/libs/portal-cache/webpart-${comCode.toLowerCase()}.json?ver=${version}`,
        }).then((res) => res.data)
    },
    /**
     * 관리자가 게시한 웹파트 데이터를 캐시를 로드 합니다.
     */
    loadWebpartCacheV3(
        comCode: string,
        version: number
    ): Promise<appbase.cache.TWebpartV3[]> {
        const filename = `webparts-${comCode.toLowerCase()}.json`
        return axios({
            method: 'GET',
            url: `/cm/gres/libs/portal-cache/${filename}?ver=${version}`,
        }).then((res) => res.data)
            .catch((err) => null)
    },
    /**
     * 관리자가 배포한 웹파트 템플릿 캐시를 로드합니다.
     */
    loadTemplateCacheV3(
        comCode: string,
        version: number
    ): Promise<appbase.cache.TWebpartV3Template[]> {
        const filename = `templates-${comCode.toLowerCase()}.json`
        return axios({
            method: 'GET',
            url: `/cm/gres/libs/portal-cache/${filename}?ver=${version}`,
        }).then((res) => res.data)
            .catch((err) => null)
    },
    /**
     * 웹파트 개인화 설정에 대한 캐시를 로드합니다.
     */
    loadPersonalCacheV3(
        comCode: string,
        personCode: string,
        version: number
    ): Promise<appbase.cache.TWebpartV3Template> {
        const filename = `WEBPART_PERSONAL-[${comCode}]${personCode}.json`
        return axios({
            method: 'GET',
            url: `/cm/gres/libs/portal-cache/personal/${filename}?ver=${version}`,
        })
            .then((res) => res.data)
            .catch((err) => null)
    },
}
